import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const getTrustpilotRating = (): number => {
  return getGlobalProperty("trustpilotRating", 0);
};
